module.exports = __webpack_public_path__ + "img/dw.4fd2b0e6.png";